import { FiSmartphone, FiMonitor, FiServer, FiGrid, FiUsers, FiZap } from "react-icons/fi";
import Reveal from "../Reveal";
import SectionHeading from "../SectionHeading";
import { useCopy } from "../../i18n/useCopy";

const icons = { mobile: FiSmartphone, web: FiMonitor, api: FiServer, dashboard: FiGrid, lead: FiUsers, speed: FiZap };

/**
 * "What I build" — the services I offer.
 *
 * @component
 */

const Services = () => {
  const t = useCopy();
  return (
  <section className="homeSection container" aria-labelledby="services-title">
    <SectionHeading eyebrow={t.sections.services.eyebrow} title={t.sections.services.title} id="services-title">
      {t.sections.services.lead}
    </SectionHeading>
    <ul className="serviceGrid">
      {t.services.map((service, i) => {
        const Icon = icons[service.icon];
        return (
          <Reveal as="li" className="serviceCard" key={service.title} delay={(i % 3) * 0.1}>
            <Icon className="serviceIcon" aria-hidden="true" />
            <h3>{service.title}</h3>
            <p>{service.text}</p>
            <ul className="tagList">
              {service.tags.map((tag) => (
                <li key={tag}>{tag}</li>
              ))}
            </ul>
          </Reveal>
        );
      })}
    </ul>
  </section>
  );
};

export default Services;
